<template>
    <div>
        <geometry-element
                selectable
                movable
                resizable
                :connectable="!isReadOnly"
                :deletable="!isReadOnly"
                :id.sync="value.elementView.id"
                :x.sync="value.elementView.x"
                :y.sync="value.elementView.y"
                :width.sync="value.elementView.width"
                :height.sync="value.elementView.height"
                :angle.sync="value.elementView.angle"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:dblclick="openPanel"
                v-on:rotateShape="onRotateShape"
                v-on:labelChanged="onLabelChanged"
                v-on:addedToGroup="onAddedToGroup"
                v-on:removeShape="onRemoveShape(value)"
                :label.sync="name"
                :image.sync="setImg"
                :_style="{
                    'label-angle':value.elementView.angle,
                    'font-weight': 'bold','font-size': '16'
                }"
                v-on:contextmenu.prevent.stop="handleClick($event)"
        >

            <geometry-rect
                    :_style="{
                        'fill-r': 1,
                        'fill-cx': .1,
                        'fill-cy': .1,
                        'stroke-width': 1.4,
                        'stroke': '#326ce5',
                        fill: '#326ce5',
                        'fill-opacity': 1,
                        r: '1',
                        'z-index': '998'
                    }"
            ></geometry-rect>

            <sub-controller
                    :image="'terminal.png'"
                    @click.prevent.stop="handleClick($event)"
            ></sub-controller>

            <sub-elements>
                <!--title-->
                <text-element
                        :sub-width="'100%'"
                        :sub-height="25"
                        :sub-top="0"
                        :sub-left="0"
                        :text="'RoleBinding'">
                </text-element>
                <image-element
                        :image="imgSrc"
                        :sub-bottom="5"
                        :sub-left="5"
                        :sub-width="25"
                        :sub-height="25">
                </image-element>
            </sub-elements>

            <k8s-sub-controller
                    v-for="(connectableType, idx) in filterConnectionTypes"
                    :key="idx"
                    :element="value"
                    :image="connectableType.src"
                    :type="connectableType.component">
            </k8s-sub-controller>
        </geometry-element>

        <property-panel
                v-if="propertyPanel"
                v-model="value"
                :img="imgSrc"
                :readOnly="isReadOnly"
                @close="closePanel"
        >
        </property-panel>

        <vue-context-menu
            :elementId="value.elementView.id"
            :options="menuList"
            :ref="'vueSimpleContextMenu'"
            @option-clicked="optionClicked">
        </vue-context-menu>
    </div>
</template>

<script>
    import Element from "../KubernetesElement";
    import PropertyPanel from './RoleBindingPropertyPanel'
    import ImageElement from "../../../opengraph/shape/ImageElement";

    export default {
        mixins: [Element],
        name: 'roleBinding',
        components: {
            ImageElement,
            "property-panel": PropertyPanel
        },
        props: {},
        computed: {
            defaultStyle() {
                return {}
            },
            className() {
                return 'RoleBinding'
            },
            imgSrc() {
                return `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/kubernetes/rb.svg`
            },
            createNew(elementId, x, y, width, height, object) {
                return {
                    _type: this.className(),
                    name: '',
                    namespace: '',
                    elementView: {
                        '_type': this.className(),
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': width,
                        'height': height,
                        'style': JSON.stringify({}),
                        'angle': 0,
                    },
                    object: object ? object: {
                        "apiVersion": "rbac.authorization.k8s.io/v1",
                        "kind": "RoleBinding",
                        "metadata": {
                            "name": "",
                            "namespace": "default",
                        },
                        "subjects": [
                            {
                                "kind": "",
                                "name": "",
                                "apiGroup": ""
                            }
                        ],
                        "roleRef": {
                            "kind": "Role",
                            "name": "",
                            "apiGroup": "rbac.authorization.k8s.io"
                        }
                    },
                    status: null,
                    connectableType: ["Role", "ClusterRole", "ServiceAccount"],
                    outboundRole: null,
                    outboundServiceAccount: null,
                }
            },
            name() {
                try {
                    return this.value.object.metadata.name;
                } catch (e) {
                    return "Untitled";
                }
            },
            namespace: {
                get: function() {
                    return this.value.object.metadata.namespace
                },
                set: function (newVal){
                    this.value.object.metadata.namespace = newVal
                }
            },
            outboundRoleName() {
                try {
                    return this.value.outboundRole.object.metadata.name;
                } catch(e) {
                    return "";
                }
            },
            outboundServiceAccountName() {
                try {
                    return this.value.outboundServiceAccount.object.metadata.name;
                } catch(e) {
                    return "";
                }
            },
        },
        data: function () {
            return {};
        },
        created: function () {
        },
        mounted(){
            var me = this;

            this.$EventBus.$on(`${me.value.elementView.id}`, function (obj) {

                if(obj.action=="addRelation" && obj.element && obj.element.targetElement && ( obj.element.targetElement._type == "Role" || obj.element.targetElement._type == "ClusterRole" )) {
                    me.value.outboundRole = obj.element.targetElement;
                }

                if(obj.action=="deleteRelation" && obj.element && obj.element.targetElement && ( obj.element.targetElement._type == "Role" || obj.element.targetElement._type == "ClusterRole" )){
                    me.value.outboundRole = null;
                }

                if(obj.action=="addRelation" && obj.element && obj.element.targetElement && obj.element.targetElement._type == "ServiceAccount") {
                    me.value.outboundServiceAccount = obj.element.targetElement;
                }

                if(obj.action=="deleteRelation" && obj.element && obj.element.targetElement && obj.element.targetElement._type == "ServiceAccount"){
                    me.value.outboundServiceAccount = null;
                }

            })

        },
        watch: {
            name(val) {
                var me = this;
                me.value.name = val;
                me.refresh()
            },
            outboundRoleName(val) {
                var me = this
                me.value.object.roleRef.name = val
                me.value.object.roleRef.kind = me.value.outboundRole.object.kind
                me.value.object.metadata.name = me.value.object.subjects[0].name + '-is-' + val
            },
            outboundServiceAccountName(val) {
                var me = this
                me.value.object.subjects[0].name = val
                me.value.object.subjects[0].kind = "ServiceAccount"
                me.value.object.metadata.name = val + '-is-' + me.value.object.roleRef.name
            },
        },
        methods: {
        }
    }
</script>
  
<style>

</style>